'use strict';

export const ASSET_TASK_CLASS_NAME = 'AssetTaskDomain';
export const ASSET_TASK_COLLECTION = 'asset-tasks';

export const TASK_CLASS_NAME = 'TaskDomain';
export const TASK_COLLECTION = 'tasks';



// WEBPACK FOOTER //
// ./src/js/tasks/domain/config.js